export const NotFound : React.FC = () => {
    return <div className='w-full flex flex-col items-center space-y-8 mt-12'>
        <h1 className='text-3xl text-center'> 404 - Whoopsie!</h1>
        <img src='https://i.pinimg.com/originals/66/0b/3e/660b3e203e827450ff115506993a3ded.jpg'/>
        <p>There's nothing to see here.</p>
    </div>
}